import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import { CreateTransactionForm } from './CreateTransactionForm';
import { PaylinkCustomerInfoResponse } from '../../../../store/modules/paylink/types';
import { DialogCloseButton } from '../../../../components/core/DialogCloseButton';
import { useMerchant } from '../../../../contexts/MerchantContext';
import { useGetPublicMerchantQuery } from '../../../../store/modules/merchant/api';
import { useCreateTransaction } from '../../../../hooks/useCreateTransaction';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  preSelectedCustomer?: PaylinkCustomerInfoResponse;
}

export const CreateTransactionModal = ({ isOpen, onClose, preSelectedCustomer }: Props) => {
  const { merchantId } = useMerchant();
  const { data: publicData } = useGetPublicMerchantQuery(merchantId, { skip: !merchantId });
  const { createTransaction } = useCreateTransaction({ merchantId });

  return (
    <Dialog open={isOpen} onClose={onClose} PaperProps={{ sx: { borderRadius: 4 } }}>
      <DialogTitle sx={{ fontSize: '16px', fontWeight: 600 }}>
        Create card on file transaction
      </DialogTitle>
      <DialogCloseButton onClose={onClose} />
      <DialogContent sx={{ pt: 3, overflowX: 'hidden' }} dividers>
        <CreateTransactionForm
          merchantId={merchantId}
          onSubmit={(data) => createTransaction(data).then(() => onClose())}
          currency={publicData?.acceptedCurrency}
          preSelectedCustomer={preSelectedCustomer}
        />
      </DialogContent>
    </Dialog>
  );
};
